import { Box } from '@mui/joy';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ContentLayout } from '@/components/ContentLayout';
import { HeaderListItemButtonLink } from '@/components/router/HeaderListItemButtonLink';

export const Route = createFileRoute('/_content')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ContentLayout>
      <Box sx={{ display: { xs: 'block', sm: 'none' }, mt: -2, mb: 3 }}>
        <HeaderListItemButtonLink to="/">Startseite</HeaderListItemButtonLink>
      </Box>

      <Outlet />
    </ContentLayout>
  );
}
